import { RealityCheckActionType } from '../optimistic.types';

export const realityCheck = (
  transactionId: string,
): RealityCheckActionType => ({
  type: '@optimistic/REALITY_CHECK',
  transactionId,
});
